// WhatsApp helper
export const WHATSAPP_NUMBER = "971585727016";
export const WHATSAPP_MESSAGE =
  "Voglio svolgere la formazione con Miriana e Benito e bloccare il mio posto subito";

export function buildWhatsAppUrl(message = WHATSAPP_MESSAGE) {
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
}

export function openWhatsApp(message = WHATSAPP_MESSAGE) {
  const url = buildWhatsAppUrl(message);
  if (typeof window !== "undefined") {
    window.open(url, "_blank", "noopener,noreferrer");
  }
}
